import React, { useEffect, useState } from "react";
import { actionCreators } from "../store/CreateRequestState";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Paper, Grid, Box, Button } from "@mui/material";
import {
    FormContainer, FormSubmitButton, selectRequiredRule, FormSelect, FormNumericField
} from "../form";

import { useNavigate } from "react-router-dom";
import { useAppStyles } from "../styles";
import { useWatch } from "react-hook-form";

const RequestForm = props => {
    const { clients } = props;
    const { classes: appClasses } = useAppStyles();
    const [showClientDetails, setShowClientDetails] = useState(false);

    const clientId = useWatch({
        name: "clientId",
        defaultValue: clients[0].value
    });

    const selectedClient = clients.find(c => c.value === clientId);

    useEffect(() => {
        setShowClientDetails(false);
    }, [setShowClientDetails, clientId]);

    return (
        <Grid container className={appClasses.formWrapper} component={Paper}>
            <Grid item xs={12} className={appClasses.formSectionTitle}>
                <Typography variant="h6">New request</Typography>
            </Grid>
            <Grid container item xs={6} className={appClasses.requestInputWrapper}>
                <Grid item xs={12}>
                    <FormSelect
                        name="clientId"
                        label="Client *"
                        className={appClasses.formTextField}
                        options={clients}
                        defaultValue={clients[0].value}
                        rules={{
                            validate: {
                                required: selectRequiredRule("Select a client.", false, "")
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormNumericField
                        numericType="decimal"
                        name="requestedAmount"
                        label="Credit amount *"
                        minValue={100}
                        maxValue={100000}
                        displayRange={true}
                        rules={{ required: true }}
                        errorMessage={"Enter credit amount."}
                        className={appClasses.formTextField}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormNumericField
                        numericType="integer"
                        name="creditDuration"
                        label="Credit duration (months) *"
                        minValue={3}
                        maxValue={120}
                        displayRange={true}
                        rules={{ required: true }}
                        errorMessage={"Enter credit amount."}
                        className={appClasses.formTextField}
                    />
                </Grid>
            </Grid>
            <Grid container item xs={6} className={appClasses.profileWrapper}>
                <Grid className={appClasses.profileTitleRow} item xs={12}>
                    <Typography variant="h6">Client profile</Typography>
                    {(clientId === "" || selectedClient == null) && (<Typography className={appClasses.noProfileMsg}>Please select a client.</Typography>)}
                    {clientId !== "" && selectedClient && (
                        <>
                            <Box className={appClasses.profileDesc}>{selectedClient.description}</Box>
                            <Button variant="outlined" className={appClasses.detailsBtn} onClick={() => setShowClientDetails(!showClientDetails)}>{showClientDetails ? "Hide details" : "Show details"}</Button>
                        </>
                    )}
                </Grid>
                {clientId !== "" && selectedClient && (
                    <>
                        {showClientDetails && (
                            <>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT UNCATEGORIZED PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumTotalPaymentsMccCatMissingMccToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT POS PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumTotalPaymentsSubtotalToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">SUM DEBIT CARD PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumDcTotalPaymentsTotalL3d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">SUM NON-NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumDcTotalPaymentsMccCatCat.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumDcTotalPaymentsAtmWithdrawalToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT FEES / INTEREST PAYMENTS TO TOTAL PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumTotalPaymentsFeeOrInterestToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">COUNT NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countDcTotalPaymentsAtmWithdrawal.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS ON WORK DAYS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumWorkingDaysTotalPaymentsAtmWithdrawalToTotalPercL3d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">COUNT NON-NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countDcTotalPaymentsMccCatCat.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">SUM PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumDcTotalPaymentsTotalL1d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT CREDIT CARD POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countCcTotalPaymentsSubtotalToTotalPercL3d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">RATIO CREDIT CARD PAYMENTS COUNT TO DEBIT CARD PAYMENTS COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countCcTotalRatioPos.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">SUM NETWORK ATM DEBIT CARD WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumDcTotalPaymentsAtmWithdrawal.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countTotalPaymentsSubtotalToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS ON WORK DAYS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.sumWorkingDaysTotalPaymentsAtmWithdrawalToTotalPercL1d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">MEAN CREDIT CARD PAYMENT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.meanCcTotalPaymentsTotal.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT LEISURE AND ENTERTAINMENT PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countTotalPaymentsMccCatCatToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT CREDIT CARD POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countCcTotalPaymentsSubtotalToTotalPercL1d.toFixed(2)}</Box>
                                </Grid>
                                <Grid className={appClasses.profileRow} item xs={12}>
                                    <Typography component="div">PERCENT FEES / INTEREST PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                                    <Box className={appClasses.profileValue}>{selectedClient.countTotalPaymentsFeeOrInterestToTotalPerc.toFixed(2)}</Box>
                                </Grid>
                            </>
                        )}
                    </>
                )}
            </Grid>
            <Grid item xs={12} className={appClasses.formActions}>
                <FormSubmitButton>Submit</FormSubmitButton>
            </Grid>
        </Grid>
    );
};


const CreateRequestPage = props => {
    const { createRequest, getClients, loading, clients } = props;
    const navigate = useNavigate();

    useEffect(() => {
        getClients(navigate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <FormContainer isReadOnly={false} handleSubmit={data => createRequest(data, navigate)} isLoading={loading} isSkeleton={false}>
            <RequestForm clients={clients} />
        </FormContainer>
    );
}

export default connect(
    (state) => state.createRequest,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(CreateRequestPage)
